import Bugsnag from "@bugsnag/js";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { sendAnalytics } from "@/utils/analytics";
import { showNotification } from "@/redux/actions/notification";
import { borrowerService } from "@/modules/contacts/features/borrower/store/services/borrower-service";
import { BORROWER_SERVICE_TAG } from "@/modules/contacts/features/borrower/utils/borrower-service-tags";
import { BORROWER_ANALYTIC_EVENTS } from "@/modules/contacts/features/borrower/utils/borrower-analytic-events";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { CONTACT_SERVICE_TAG } from "@/modules/contacts/utils/contact-service-tags";
import { contactService } from "@/modules/contacts/store/services/contact-service";

const addBorrower = borrowerService.injectEndpoints({
  endpoints: builder => ({
    addBorrower: builder.mutation({
      query: body => ({
        url: "borrowers",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: BORROWER_SERVICE_TAG, id: LIST_SERVICE_TAG }],
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          sendAnalytics(BORROWER_ANALYTIC_EVENTS.BORROWER_CREATED, data);
          dispatch(
            showNotification({
              ...DEFAULT_NOTIFICATION_PAYLOAD,
              message: {
                ...DEFAULT_NOTIFICATION_PAYLOAD.message,
                description: "Borrower has been created!",
                options: {
                  variant: NOTIFICATION_VARIANTS.SUCCESS,
                },
              },
            }),
          );
          dispatch(contactService.util.invalidateTags([CONTACT_SERVICE_TAG]));
        } catch (err) {
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useAddBorrowerMutation } = addBorrower;

